import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function Settings() {
  const { user, logout } = useAuth();
  const [currency, setCurrency] = useState(user?.currency || 'USD');
  const [phone, setPhone] = useState(user?.phone || '');

  const handleSave = () => {
    toast.success('Settings saved!');
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-900">Settings</h1>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <h3 className="text-lg font-semibold mb-4">Profile Information</h3>
        <div className="space-y-4">
          <div><label className="block text-sm font-medium text-gray-700 mb-1">Email</label><input type="email" value={user?.email || ''} disabled className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-gray-500" /></div>
          <div><label className="block text-sm font-medium text-gray-700 mb-1">Username</label><input type="text" value={user?.username || ''} disabled className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-gray-500" /></div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Currency</label><select value={currency} onChange={e => setCurrency(e.target.value)} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"><option value="USD">USD ($)</option><option value="EUR">EUR (€)</option><option value="GBP">GBP (£)</option><option value="KES">KES (KSh)</option></select></div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Phone</label><input type="tel" value={phone} onChange={e => setPhone(e.target.value)} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500" placeholder="+254..." /></div>
          </div>
          <button onClick={handleSave} className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg hover:bg-indigo-700">Save Changes</button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <h3 className="text-lg font-semibold mb-4">Subscription</h3>
        <div className="flex items-center justify-between">
          <div><p className="font-medium text-gray-900">{user?.subscriptionPlan || 'Free'} Plan</p><p className="text-sm text-gray-500">Status: {user?.subscriptionStatus || 'inactive'}</p></div>
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${user?.subscriptionStatus === 'active' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>{user?.subscriptionStatus === 'active' ? 'Active' : 'Inactive'}</span>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <h3 className="text-lg font-semibold text-red-700 mb-4">Danger Zone</h3>
        <button onClick={logout} className="bg-red-600 text-white px-6 py-2.5 rounded-lg hover:bg-red-700">Logout</button>
      </div>
    </div>
  );
}
